module.exports = __webpack_public_path__ + "files/e89483a0909c0f05a0d33808f73273b1.png";